import { render, staticRenderFns } from "./PageResendEmail.vue?vue&type=template&id=64274fae&scoped=true&"
import script from "./PageResendEmail.vue?vue&type=script&lang=js&"
export * from "./PageResendEmail.vue?vue&type=script&lang=js&"
import style0 from "./PageResendEmail.vue?vue&type=style&index=0&id=64274fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64274fae",
  null
  
)

export default component.exports